import {Node, Text} from "../../../../../../pkg/slate.js";
export const getEditorPlainText = (editor) => Array.from(Node.texts(editor)).map((nodeEntry) => Text.isText(nodeEntry[0]) ? nodeEntry[0].text.trim() : "").filter((s) => s !== "").join(" ");
